/**
 * 定时器相关工具函数
 */

/**
 * 增强版延时函数，支持取消功能
 * @param ms 延迟毫秒数
 * @returns 包含延时Promise和取消方法的对象
 */
export function createDelay(ms: number) {
  let timeoutId: ReturnType<typeof setTimeout>;
  let isCancelled = false;
  
  const delayPromise = new Promise<void>((resolve) => {
    timeoutId = setTimeout(() => {
      if (!isCancelled) {
        resolve();
      }
    }, ms);
  });
  
  const cancel = () => {
    isCancelled = true;
    clearTimeout(timeoutId);
  };
  
  return {
    promise: delayPromise,
    cancel
  };
}

/**
 * 简化版延时函数（在不需要取消功能时使用）
 * @param ms 延迟毫秒数
 * @returns Promise对象
 */
export const delay = (ms: number): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms));
};